import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { meQuery } from '@/features/auth/auth-api';
import { LoginForm } from '@/features/auth/login-form';
import { safeRedirect } from '@/features/auth/safe-redirect';

export const Route = createFileRoute('/_public/login')({
  // `error`: set by the API when a Microsoft sign-in failed (Better Auth error code).
  // `password`: open the customer access right away (links from password reset and invitation).
  validateSearch: z.object({
    redirect: z.string().optional(),
    error: z.string().optional(),
    password: z.boolean().optional(),
  }),
  beforeLoad: async ({ context, search }) => {
    const me = await context.queryClient.query(meQuery);
    if (me !== null && !me.twoFactorSetupRequired)
      throw redirect({ href: safeRedirect(search.redirect) });
  },
  component: LoginPage,
});

function LoginPage() {
  const { redirect: target, error, password } = Route.useSearch();
  return <LoginForm redirect={target} microsoftError={error} passwordOpen={password} />;
}
